import { onBeforeMount } from "vue";
import { useGlobalStore, useDataLayerStore, useJourneyStore } from "@/stores";

const PRE_HIDING_CLASSNAME = "hidden";
const PRE_HIDING_TIMEOUT = 3000;

const hide = (next: Function) => {
    document.body.classList.add(PRE_HIDING_CLASSNAME);
    return setTimeout(next, PRE_HIDING_TIMEOUT);
};
const reveal = (timeout: number | null) => () => {
    timeout && clearTimeout(timeout);
    document.body.classList.remove(PRE_HIDING_CLASSNAME);
};

const initDatalayer = () => {
    const dataLayer = useDataLayerStore();
    const journey = useJourneyStore();
    journey.initJourney();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).app = {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        digitalData: dataLayer.digitalData,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        adobeDataLayer: dataLayer.adobeDataLayer,
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).app.digitalData();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).app.adobeDataLayer();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).digitalData = {
        journey: {
            campaign: journey.campaign,
            agencyNo: journey.agencyNumber,
            directagenttraffic: journey.agencyNumber,
        },
        page: {},
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!(window as any).adobeDataLayer) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).adobeDataLayer = [];
    }
};

export const useDataLayerScript = () => {
    onBeforeMount(() => {
        const global = useGlobalStore();

        const timeout = hide(reveal(null));

        const adobeScript = document.createElement("script");
        adobeScript.setAttribute("src", global.env.DATALAYER_URL);

        adobeScript.addEventListener("load", reveal(timeout));
        adobeScript.addEventListener("error", reveal(timeout));

        document.head.appendChild(adobeScript);

        initDatalayer();
    });
};
